// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"styles_breadcrumbs__KUiOy","routes":"styles_routes__o99tl","route":"styles_route__ZGbbQ"};